import { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { PulseTemplateModel } from 'api/dto/PulseTemplate.dto';
import { Resource } from 'model/Resource';
import { ProjectState } from 'reduxStore/project/initialState';
import {
  fetchCurrentProject,
  fetchProjectList,
  updateProject,
} from 'reduxStore/project/project/asyncActions';
import { addAsyncCasesNew } from 'shared/utils/redux';

export const projectReducer = (builder: ActionReducerMapBuilder<ProjectState.Domain>) => {
  addAsyncCasesNew(builder, fetchProjectList, (state, action) => {
    state.listResource = action.payload;
  });

  builder
    .addCase(fetchCurrentProject.fulfilled, (state, action) => {
      state.currentResource = Resource.createResolvedResource({ data: action.payload });
    })
    .addCase(fetchCurrentProject.rejected, (state, action) => {
      state.currentResource = Resource.createRejectedResource({ error: action.error });
    })
    .addCase(updateProject.fulfilled, (state, action) => {
      const currentProject = state.currentResource.data;
      if (PulseTemplateModel.isPulseTemplateModel(currentProject)) {
        const updatedTemplate = {
          ...currentProject,
          project: action.payload,
        };
        state.currentResource.data = updatedTemplate;
      } else {
        state.currentResource = Resource.createResolvedResource({ data: action.payload });
      }
    });
};
